<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>用户分组配置{{ id > 0 ? '编辑':'新增' }}</span>
        </div>
        <el-form ref="formData" :model="formData" :rules="rules" label-width="160px" class="demo-ruleForm">
          <el-row>
            <el-form-item label="分组ID">
              <el-form :inline="true">
                <el-form-item prop="groupId">
                  <el-input :disabled="id != 0" v-model.number="formData.groupId" style="width: 200px;" placeholder="分群号" />
                </el-form-item>

                <el-form-item label="分组名" prop="type" style="margin-left: 10px">
                  <el-input v-model="formData.name" style="width: 200px;" placeholder="分群号" />
                </el-form-item>
              </el-form>
            </el-form-item>
            <el-form-item label="排序" prop="limit" style="width: 400px;">
              <el-input v-model.number="formData.sort" placeholder="排序" />
            </el-form-item>
            <el-form-item label="备注" prop="remark" style="width: 400px;">
              <el-input v-model="formData.remark" type="textarea" />
            </el-form-item>
            <el-form-item size="small" label="分组定义">
              <el-select multiple v-model="formData.label">
                <el-option v-for="item in labelList" :value="item.id" :label="item.name" />
              </el-select>
            </el-form-item>
            <el-form-item v-if="false" label="分组定义">
              <el-button type="primary" @click="addCond()">+</el-button>
            </el-form-item>
            <el-form-item v-if="false">
              <el-form :inline="true">
                <el-row v-for="(item, index) in formData.condition" :key="index">
                  <el-form-item label="分组条件" style="margin-top: 10px;">
                    <el-select v-model.number="item.action" style="width: 100px" placeholder="请选择">
                      <el-option
                        v-for="(item, index) in actionTypes"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>

                  <el-form-item style="margin-top: 10px;">
                    <el-select v-model.number="item.condition" style="width: 160px" placeholder="请选择">
                      <el-option
                        v-for="(item, index) in condTypes"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                        :disabled="item.disabled"
                      />
                    </el-select>
                  </el-form-item>
                  <el-form-item v-if="item.condition === 1" style="margin-top: 10px;">
                    <el-form-item label="距离上次充值时间">
                      <el-col :span="11">
                        <el-input v-model.number="item.rmf.r.min" placeholder="最小值" style="width: 100px;" />
                      </el-col>
                      <el-col class="line" :span="1">-</el-col>
                      <el-col :span="11">
                        <el-input v-model.number="item.rmf.r.max" placeholder="最大值" style="width: 100px;" />
                      </el-col>
                    </el-form-item>
                    <el-form-item label="90天内充值次数">
                      <el-col :span="11">
                        <el-input v-model.number="item.rmf.f.min" placeholder="最小值" style="width: 100px;" />
                      </el-col>
                      <el-col class="line" :span="1">-</el-col>
                      <el-col :span="11">
                        <el-input v-model.number="item.rmf.f.max" placeholder="最大值" style="width: 100px;" />
                      </el-col>
                    </el-form-item>
                    <el-form-item label="90天内累计充值">
                      <el-col :span="11">
                        <el-input v-model.number="item.rmf.m.min" placeholder="最小值" style="width: 100px;" />
                      </el-col>
                      <el-col class="line" :span="1">-</el-col>
                      <el-col :span="11">
                        <el-input v-model.number="item.rmf.m.max" placeholder="最大值" style="width: 100px;" />
                      </el-col>
                    </el-form-item>
                  </el-form-item>

                  <el-form-item v-if="item.condition !== 1" style="margin-top: 10px;">
                    <el-select v-model.number="item.select" style="width: 160px" placeholder="请选择" @change="(v)=>typeChange(v,index)">
                      <el-option
                        v-for="(item, index) in selectTypes"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>

                  <el-form-item v-if="item.condition === 2" label="区间" style="margin-top: 10px;">
                    <el-col :span="11">
                      <el-input v-model.number="item.onlineTime.min" :disabled="item.select === 0" placeholder="最小值" style="width: 200px;" />
                    </el-col>
                    <el-col class="line" :span="1">-</el-col>
                    <el-col :span="11">
                      <el-input v-model.number="item.onlineTime.max" :disabled="item.select === 0" placeholder="最大值" style="width: 200px;" />
                    </el-col>
                  </el-form-item>

                  <el-form-item v-if="item.condition === 3" label="区间" style="margin-top: 10px;">
                    <el-col :span="11">
                      <el-input v-model.number="item.active.min" :disabled="item.select === 0" placeholder="最小值" style="width: 200px;" />
                    </el-col>
                    <el-col class="line" :span="1">-</el-col>
                    <el-col :span="11">
                      <el-input v-model.number="item.active.max" :disabled="item.select === 0" placeholder="最大值" style="width: 200px;" />
                    </el-col>
                  </el-form-item>
                  <el-form-item style="margin-top: 10px;">
                    <el-button type="danger" @click="delCond(index)">删除</el-button>
                  </el-form-item>
                </el-row>
              </el-form>
            </el-form-item>
          </el-row>
          <el-form-item style="width:100%;margin-top:50px;text-align: center">
            <el-button type="primary" @click="submitForm('formData')">保存</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getUserTypeCfg, getUserTypeList, updateUserTypeCfg } from '@/api/config/user-group-cfg'
import {getUserLabelList} from "@/api/config/user-label-cfg";

export default {
  name: 'UserGroupEdit',
  data() {
    return {
      id: 0,
      selectType: 0,
      keys: { 2: 'onlineTime', 3: 'active' },
      key: '',
      selectTypes: [{ label: '全选', value: 0 }, { label: '区间', value: 1 }],
      condTypes: [],
      between: [],
      formData: {
        id: 0,
        groupId: '',
        name: '',
        remark: '',
        sort: 0,
        condition: [
          {
            action: 0,
            condition: 1,
            select: 0,
            rmf: { r: { min: 0, max: 0 }, m: { min: 0, max: 0 }, f: { min: 0, max: 0 }},
            onlineTime: { min: 0, max: 0 },
            active: { min: 0, max: 0 }
          }
        ],
        label:[]
      },
      actionTypes: [
        { label: '并且', value: 0 },
        { label: '或者', value: 1 },
        { label: '非', value: 2 }
      ],
      rules: {
        name: [
          { required: true, message: '请输入分群名称', trigger: 'blur' }
        ],
        groupId: [
          { required: true, message: '请输入分组ID', trigger: 'blur' }
        ]
      },
      labelList:[],
    }
  },
  created() {
    this.getTypeData()
    const id = this.$route.query.id
    this.id = id
    this.labelCfg()
    if (id > 0) {
      this.getTables(id)
    }
  },
  methods: {
    labelCfg(){
      getUserLabelList(this.queryParams).then(res => {
        this.loading = false
        this.labelList = res.data.list
      })
    },
    listenChangeType() {
      this.condTypes.forEach((item, index) => {
        this.condTypes[index].disabled = false
      })

      this.formData.condition.forEach((item, index) => {
        for (const i in this.condTypes) {
          const val = this.condTypes[i]
          if (val.value === item.condition) {
            this.condTypes[i].disabled = true
            break
          }
        }
      })
    },
    getTables(id) {
      getUserTypeList({ id: id }).then(res => {
        if (res.code === 200) {
          const data = res.data.list[0]
          const cond = []
          for (const i in data.condition) {
            const val = data.condition[i]
            if (val.condition === 1) {
              cond.push({
                action: val.action,
                condition: val.condition,
                select: 0,
                rmf: {
                  r: { min: val.rfm.r[0], max: val.rfm.r[1] },
                  m: { min: val.rfm.m[0], max: val.rfm.m[1] },
                  f: { min: val.rfm.f[0], max: val.rfm.f[1] }
                }
              })
            } else if (val.condition === 2) {
              cond.push({
                action: val.action,
                condition: val.condition,
                select: (val.onlineTime[0] > 0 || val.onlineTime[1] > 0) ? 1 : 0,
                onlineTime: { min: val.onlineTime[0], max: val.onlineTime[1] }
              })
            } else {
              cond.push({
                action: val.action,
                condition: val.condition,
                select: (val.active[0] > 0 || val.active[1] > 0) ? 1 : 0,
                active: { min: val.active[0], max: val.active[1] }
              })
            }
          }
          this.formData.groupId = data.groupId
          this.formData.id = data.id
          this.formData.name = data.name
          this.formData.remark = data.remark
          this.formData.sort = data.sort
          this.formData.condition = cond
          this.formData.label = data.label
          this.listenChangeType()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    submitForm() {
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          const formData = this.formData
          // console.log(this.formData)
          if (!formData.name) {
            this.msgError('分组名称不能为空')
            return
          }
          if (!formData.groupId) {
            this.msgError('请输入分组ID')
            return
          }

          const newForm = Object.assign({}, formData)
          const condition = newForm.condition
          const newCondition = []
          console.log(newForm)
          for (const i in condition) {
            const val = condition[i]
            console.log(typeof val.condition)
            if (val.condition === 1) {
              if (val.rmf.r.min > 0 && val.rmf.r.min > val.rmf.r.max) {
                this.msgError('R 最小值不能大于大值')
                return
              }
              if (val.rmf.m.min > 0 && val.rmf.m.min > val.rmf.m.max) {
                this.msgError('R 最小值不能大于大值')
                return
              }
              if (val.rmf.f.min > 0 && val.rmf.f.min > val.rmf.f.max) {
                this.msgError('R 最小值不能大于大值')
                return
              }
              const temp = {
                action: val.action,
                condition: val.condition,
                rfm: {
                  r: [val.rmf.r.min, val.rmf.r.max],
                  f: [val.rmf.f.min, val.rmf.f.max],
                  m: [val.rmf.m.min, val.rmf.m.max]
                }
              }
              newCondition.push(temp)
            } else if (val.condition === 2) {
              if (val.onlineTime.min > 0 && val.onlineTime.min > val.onlineTime.max) {
                this.msgError('累计时长最小值不能大于大值')
                return
              }
              const temp = {
                action: val.action,
                condition: val.condition,
                onlineTime: [val.onlineTime.min, val.onlineTime.max]
              }
              newCondition.push(temp)
            } else {
              if (val.active.min > 0 && val.active.min > val.active.max) {
                this.msgError('活跃天数最小值不能大于大值')
                return
              }
              const temp = {
                action: val.action,
                condition: val.condition,
                active: [val.active.min, val.active.max]
              }
              newCondition.push(temp)
            }
          }
          newForm.condition = newCondition
          const data = JSON.stringify(newForm)
          console.log('newForm', data)
          updateUserTypeCfg({ data: data }).then(res => {
            if (res.code === 200) {
              this.msgSuccess(res.msg)
              this.$router.push({ path: '/config/user-group/index' })
              this.$nextTick(() => {
                this.$root.$emit('fetchData') // 发送事件通知列表页更新数据
              })
            } else {
              this.msgError(res.msg)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    getTypeData() {
      getUserTypeCfg().then(res => {
        if (res.code === 200) {
          this.condTypes = []
          for (const i in res.data) {
            const val = res.data[i]
            this.condTypes.push({ label: val, value: parseInt(i), disabled: false })
          }
        }
      })
    },
    addCond() {
      this.listenChangeType()
      let selectType = ''
      for (const i in this.condTypes) {
        const val = this.condTypes[i]
        if (!val.disabled) {
          selectType = val.value
          break
        }
      }

      if (!selectType) {
        this.msgError('无可选类型')
        return
      }
      console.log('可选类型', selectType)
      this.formData.condition.push({
        action: 0,
        condition: selectType,
        select: 0,
        rmf: { r: { min: 0, max: 0 }, m: { min: 0, max: 0 }, f: { min: 0, max: 0 }},
        onlineTime: { min: 0, max: 0 },
        active: { min: 0, max: 0 }
      })
    },
    delCond(i) {
      this.formData.condition = this.formData.condition.filter((item, index) => {
        return index !== i
      })
      this.listenChangeType()
    },
    typeChange(v, index) {
      this.formData.condition[index].condition
      if (cond === 1) {
        return
      }
      const cond = this.formData.condition[index].condition
      if (v === 0) {
        switch (cond) {
          case 2:
            this.formData.condition[index].onlineTime.max = 0
            this.formData.condition[index].onlineTime.min = 0
            break
          case 3:
            this.formData.condition[index].action.max = 0
            this.formData.condition[index].action.min = 0
            break
        }
      }
    }
  }
}
</script>

<style scoped>
.hide_box /deep/ .el-upload--picture-card {
  display: none;
}
.hide .el-upload--picture-card {
  display: none;
}
</style>
